module.exports = __webpack_public_path__ + "img/mp.93e49e7a.jpg";